import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreateEstimateRequest } from '../../../types/estimate.js'

import { apiClient } from '../../../lib/client.js'
import { estimateKeys } from './keys.js'

export const useCreateEstimateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (request: CreateEstimateRequest) => {
      const response = await apiClient.client.post(`/estimate/unified`, request)
      return response.status
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: estimateKeys.all })
    },
  })
}
